$(function() {
    // Sliders

    var width = $(window).width();

    if ($('#carousel-1').length > 0) {
        $('#nextStep').on('click', function() {
            if ($('#step-1 input, #step-1 select, #step-1 textarea').valid()) {
                $('#step-1').toggle('slow');
                $('#step-2').toggle('slow');
            }
        });

        $('#backStep').on('click', function() {
            $("#step-2").toggle('slow');
            $("#step-1").toggle('slow');
        });
    }

    if ($('#carousel-2').length > 0) {
        $('#nextStep-1').on('click', function() {
            if ($('#step-1 input, #step-1 select, #step-1 textarea').valid()) {
                $('#step-1').toggle('slow');
                $('#step-2').toggle('slow');
            }
        });

        $('#nextStep-2').on('click', function() {
            if ($('#step-2 input, #step-2 select, #step-2 textarea').valid()) {
                $("#step-2").toggle('slow');
                $("#step-3").toggle('slow');
            }
        });

        $('#backStep-1').on('click', function() {
            $('#step-2').toggle('slow');
            $('#step-1').toggle('slow');
        });

        $('#backStep-2').on('click', function() {
            $('#step-3').toggle('slow');
            $('#step-2').toggle('slow');
        });
    }

    if ($('.clients-slider').length > 0) {
        $('.clients-slider').slick({
            centerMode: true,
            slidesToShow: 3,
            centerPadding: '63px',
            responsive: [{
                    breakpoint: 1279,
                    settings: {
                        centerPadding: '36px'
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '60px'
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '10%',
                        arrows: false,
                        infinite: false
                    }
                }
            ]
        });
    }

    if ($('#processSlider').length > 0) {
        var $processSlider = $('#processSlider').slick({
            focusOnSelect: true,
            centerMode: false,
            centerPadding: '0px',
            initialSlide: 0,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            nextArrow: $('.next'),
            prevArrow: $('.previous'),
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1
                }
            }]
        });

        $('.slick-slide[data-slick-index="0"] .row').addClass('active');
        $('.content[data-slide-content="1"]').toggleClass('active');

        $processSlider.on('click', '.slick-slide', function() {
            $('.slick-slide .row').removeClass('past').removeClass('active');

            var currentIndex = parseInt($(this).data('slick-index'));

            $('.slider-contents .content').removeClass('active');
            $('.content[data-slide-content="' + (currentIndex + 1) + '"]').addClass('active');

            for (var i = 0; i < 6; i++) {
                if (i < currentIndex) {
                    $('.slick-slide[data-slick-index="' + i + '"] .row').addClass('past');

                    continue;
                }

                if (i === currentIndex) {
                    $('.slick-slide[data-slick-index="' + i + '"] .row').addClass('active');

                    continue;
                }
            }
        });
    }

    if ($('#panelsSlider').length > 0) {
        $('#panelsSlider').slick({
            autoplay: true,
            centerMode: false,
            centerPadding: '0px',
            initialSlide: 0,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            responsive: [{
                breakpoint: 641,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 481,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    }

    // TODO: unused js from outdated templates

    // if ($('.team-slider-wrapper').length > 0) {
    //     $('.team-slider').slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         infinite: false,
    //         nextArrow: $(".next-slide-team"),
    //         prevArrow: $(".prev-slide-team")
    //     });
    // }

    // if ($('.certificate-slider-wrapper').length > 0) {
    //     $('.certificate-slider').slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         infinite: false,
    //         nextArrow: $(".next-slide-certificate"),
    //         prevArrow: $(".prev-slide-certificate")
    //     });
    // }

    // if (($('.case-studies-container.slider').length > 0) && (width < 1024)) {
    //     $('.case-studies-container.slider').slick({
    //         slidesToShow: 2,
    //         infinite: false,
    //         arrows: false,
    //         responsive: [{
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1,
    //                 centerMode: true,
    //                 centerPadding: '10%'
    //             }
    //         }]
    //     });
    // }

    // if (width < 1025) {
    //     $('.plans-scroll').mCustomScrollbar({
    //         axis: 'x',
    //         theme: 'dark-thin',
    //         autoExpandScrollbar: true,
    //         advanced: {
    //             autoExpandHorizontalScroll: true
    //         }
    //     });
    // }

    // if (width < 769) {
    //     $('.plans-scroll').mCustomScrollbar('destroy');
    // }
});